export enum BenchmarkOrderType {
  RESERVED1,
  Standard,
  RiskTransferSource,
  RiskTransferTarget,
  PositionOrder,
}

export namespace BenchmarkOrderType {
  let elements = [
    BenchmarkOrderType.RESERVED1,
    BenchmarkOrderType.Standard,
    BenchmarkOrderType.RiskTransferSource,
    BenchmarkOrderType.RiskTransferTarget,
    BenchmarkOrderType.PositionOrder,
  ];
  let alias = "com.bcdfx.model.BenchmarkOrderType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
